










import { Component, Prop, Vue } from 'vue-property-decorator';

type Brand = 'nyt' | 'atlantic' | 'guardian' | 'npr' | 'business-insider' | 'wired' | 'tech-crunch';

interface Icon {
  logo: string;
  commentLogo: string;
}

type PossibleBrandIcons = {
  [key in Brand]: Icon;
};

@Component({})
export default class PublishersList extends Vue {
  @Prop({ type: Boolean, default: false }) readonly reduced!: boolean;

  private items: PossibleBrandIcons = {
    nyt: {
      logo: 'b-sprite-publishers-nyt',
      commentLogo: 'b-sprite-publishers-tantalizing',
    },
    atlantic: {
      logo: 'b-sprite-publishers-atlantic',
      commentLogo: 'b-sprite-publishers-advanced',
    },
    guardian: {
      logo: 'b-sprite-publishers-guardian',
      commentLogo: 'b-sprite-publishers-brilliant',
    },
    npr: {
      logo: 'b-sprite-publishers-npr',
      commentLogo: 'b-sprite-publishers-for-promising-minds',
    },
    'business-insider': {
      logo: 'b-sprite-publishers-business-insider',
      commentLogo: 'b-sprite-publishers-smart',
    },
    wired: {
      logo: 'b-sprite-publishers-wired',
      commentLogo: 'b-sprite-publishers-generation-of-geniuses',
    },
    'tech-crunch': {
      logo: 'b-sprite-publishers-tech-crunch',
      commentLogo: 'b-sprite-publishers-onto-something',
    },
  };

  private fullList: Brand[] = [
    'nyt',
    'atlantic',
    'guardian',
    'npr',
    'business-insider',
    'wired',
    'tech-crunch',
  ];

  private reducedList: Brand[] = ['nyt', 'atlantic'];

  private get iconList(): Icon[] {
    const iconListItems: Icon[] = [];
    const list = this.reduced ? this.reducedList : this.fullList;
    for (const item of list) {
      iconListItems.push(this.items[item]);
    }
    return iconListItems;
  }
}
